<template>
  <div class="media-chat mb-2 px-2 mt-1">
    <div class="media-chat vstack gap-3">
      <div v-for="m in context" :key="m._id" class="media-chat-item hstack align-items-start gap-3"
        :class="m.role == 'user' ? 'media-chat-item-reverse' : ''">
        <span class="d-block selectNone">
          <template v-if="m.role == 'assistant'">
            <img src="../assets/images/redrobot.jpg" class="w-40px h-40px rounded-pill selectNone" alt="">
          </template>
          <template v-else>
            <img src="../assets/images/user_m_4.png" class="w-40px h-40px rounded" alt="">
          </template>
          <!--<span class="status-indicator bg-success"></span> -->
        </span>

        <div>
          <div class="media-chat-message fs-sm wmin-300">
            <div class="fs-sm lh-sm selectNone">
              <span class="fw-semibold">{{ m.role == 'assistant' ? 'MAKER-GPT' + `
                ${m.model || ''}` : (m.user?.first_name || '') + ' ' + (m.user?.last_name || '')}}</span>
              <!--<span class="opacity-50 ms-2">Wed, 4:20 pm</span>-->
            </div>
            <div v-html="MarkdownToHTML(m.content)"></div>
            <div v-if="m.tools && m.tools.length > 0" class="chat-attachment">
              <div class="chat-attachment__header">
                <span class="fw-semibold">tools</span>
                <span class="opacity-75 ms-2">{{ m.tools.length }}</span>
              </div>

              <div class="chat-attachment__tools">
                <div v-for="t in m.tools" :key="t.id" class="chat-attachment__tool">
                  <span class="badge bg-info bg-opacity-20 text-info">{{ t.type }}</span>
                  <span v-if="t.model" class="ms-2 text-muted">{{ t.model }}</span>
                  <span v-if="t.size" class="ms-2 text-muted">· {{ t.size }}</span>
                </div>
              </div>

              <div v-if="m.output && m.output[0]" class="chat-attachment__output">
                <div v-if="getOutputImageSrc(m)" class="chat-attachment__imageWrap">
                  <img
                    :src="getOutputImageSrc(m)"
                    alt="generated"
                    class="chat-attachment__image"
                  >
                </div>
                <div v-if="getOutputRevisedPrompt(m)">
                  <span class="fw-semibold">revised prompt: </span>
                  {{ getOutputRevisedPrompt(m) }}
                </div>
              </div>
            </div>
            <div
              v-if="Array.isArray(m.content) && m.content.find(el => el.type === 'image_url')"
              class="d-flex">
              <a
                :href="m.content.find(el => el.type === 'image_url').image_url.url"
                target="_blank" class="text-white ms-auto">
                  <i class="ph-file-jpg"></i>
              </a>
            </div>
          </div>
          <div class="d-flex justify-content-between fs-sm text-muted mt-1 selectNone">
            <div v-if="m.creationDate" class="form-text text-end">{{ m.creationDate ?
              moment(m.creationDate).format('YYYY-MM-DD HH:mm') : '' }}</div>
            <div v-if="m.usage" class="fs-sm text-muted mt-1 me-2">Использовано: {{ m.usage.total_tokens || '' }} токенов / {{ (m.usage.prompt_cost?.toFixed(4) || 0) }}р.
            </div>
            <div v-if="m.files && m.files.length > 0">
              Файлы: <a
              class="badge bg-warning rounded-pill cursor-pointer me-1"
              v-for="(f, index) in m.files" :key="index"
              :href="f.publicPath"
              target="_blank"
              >{{ index + 1 }}</a>
            </div>
            <a href="#"
              v-if="m.system && m.system[0]"
              @click.prevent="modalContent={title: 'Состав запроса System', text: m.system[0].content}"
              data-bs-toggle="modal" data-bs-target="#modal_scrollable"
              class="badge bg-info bg-opacity-20 text-info">system</a>
            <a href="#" @click.prevent="copyTextToBuffer(m.content)"
              class="badge bg-info bg-opacity-20 text-info">Копировать</a>
          </div>
          <!--
          <div v-if="Array.isArray(m.content) && m.content.find(el => el.type === 'image_url')"
            class="fs-sm text-muted mt-2 selectNone">
            <a :href="m.content.find(el => el.type === 'image_url').image_url.url" target="_blank"
              class="fs-sm text-muted" v-if="Array.isArray(m.content)">
              Изображение: {{ m.content.find(el => el.type === 'image_url').image_url.url.split('/').at(-1) }}
            </a>
          </div>
          -->
        </div>
      </div>

      <section ref="lastMessageRef">
      </section>

      <div
        v-if="AIThinking"
        class="media-chat-item hstack align-items-start gap-3">
        <a href="#" class="d-block status-indicator-container">
          <img src="../assets/images/redrobot.jpg" class="w-40px h-40px rounded-pill" alt="">
          <span class="status-indicator bg-success"></span>
        </a>
        <div class="d-flex flex-column">
          <div class="align-self-center">
            <span class="fw-semibold">GptMAKER</span> is typing
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="">
            <TimerWithSpinner :duration="500"></TimerWithSpinner>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="modal_scrollable" class="modal fade" tabindex="-1" style="display: none;"  aria-hidden="true"
    role="dialog">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalContent.title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <pre v-html="MarkdownToHTML(modalContent.text)"></pre>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Закрыть</button>
          <button type="button" class="btn btn-primary"
            @click.prevent="copyTextToBuffer(modalContent.text)"
            data-bs-dismiss="modal">Копировать в буфер</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import moment from 'moment'
import showdown from 'showdown'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import TimerWithSpinner from '@/components/TimerWithSpinner.vue'

const converter = new showdown.Converter()

export default {
  name: 'ChatBody',
  components: {
    TimerWithSpinner
  },
  props: {
    context: Array,
    AIThinking: Boolean
  },
  setup (props) {
    const lastMessageRef = ref(null)
    const contextLength = computed(() => props.context.length)
    const modalContent = ref({
      title: '',
      text: ''
    })

    const getOutputImageSrc = function (m) {
      const result = m?.output?.[0]?.result
      if (!result || typeof result !== 'string') return ''
      const trimmed = result.trim()
      if (!trimmed) return ''
      if (trimmed.startsWith('data:image/')) return trimmed
      return `data:image/png;base64,${trimmed}`
    }

    const getOutputRevisedPrompt = function (m) {
      const p = m?.output?.[0]?.revised_prompt
      return typeof p === 'string' ? p : ''
    }

    const wrapScriptTagsInPre = function (text) {
      const scriptRegex = /(<script(?:\s+setup)?\s*>)([\s\S]*?)(<\/script>)/gi
      return text.replace(scriptRegex, (match, openTag, content, closeTag) => {
        return `${openTag}${content}${closeTag}`
      })
    }
    const MarkdownToHTML = function (content) {
      try {
        let text = Array.isArray(content)
          ? content.find(el => el.type === 'text').text
          : content
        text = text ? text.replace(/<a/g, '<a target="_blank"') : ''
        return converter.makeHtml(wrapScriptTagsInPre(text))
      } catch (err) {
        console.log(content, err)
        return ''
      }
    }

    const copyTextToBuffer = function (text) {
      navigator.clipboard.writeText(text[0]?.text ? text[0]?.text : text)
      toast('Скопировано в буфер обмена', {
        autoClose: 1000
      })
    }

    function scrollTo (view) {
      view.value?.scrollIntoView({ behavior: 'smooth' })
    }

    watch(contextLength, (oldV, newV) => {
      setTimeout(() => { scrollTo(lastMessageRef) }, 10)
    })

    setTimeout(() => {
      scrollTo(lastMessageRef)
    }, 10)

    return {
      moment,
      MarkdownToHTML,
      copyTextToBuffer,
      lastMessageRef,
      scrollTo,
      modalContent,
      TimerWithSpinner,
      getOutputImageSrc,
      getOutputRevisedPrompt
    }
  }
}
</script>

<style>
.selectNone {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.chat-attachment {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.chat-attachment__header {
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
}

.chat-attachment__tools {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chat-attachment__tool {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.chat-attachment__output {
  margin-top: 10px;
}

.chat-attachment__imageWrap {
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.chat-attachment__image {
  height: 120px;
  width: auto;
  display: block;
  object-fit: contain;
}
</style>
